var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { MenuItem as MuiMenuItem } from '@mui/material';
import Select from '../SelectInput';
import Text from '../Text';
import colors from '../../themes/colors';
import { formatSelectedDateRange, getSelectedTimeFrame } from './formatSelectedDateRange';
var StyledMuiItem = styled(MuiMenuItem)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:hover {\n    background-color: inherit;\n  }\n"], ["\n  &:hover {\n    background-color: inherit;\n  }\n"])));
var StyledSelect = styled(Select)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 360px;\n  background-color: ", ";\n"], ["\n  width: 360px;\n  background-color: ", ";\n"])), function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? colors.neutral10 : 'white');
});
var DatePickerSelect = function (props) {
    var children = props.children, dateRange = props.dateRange, isOpen = props.isOpen, onOpen = props.onOpen;
    var selectedTimeFrame = getSelectedTimeFrame(dateRange);
    return (_jsx(StyledSelect, __assign({ noPadding: true, value: "picker", isOpen: isOpen, forceOpen: isOpen, onSelectClick: onOpen, renderValue: function () { return (_jsx(Text, __assign({ variant: "body2", color: "bigBangBlack" }, { children: "".concat(selectedTimeFrame, ": ").concat(formatSelectedDateRange(dateRange)) }))); } }, { children: _jsx(StyledMuiItem, __assign({ style: {
                padding: 0,
                backgroundColor: 'transparent',
                cursor: isOpen ? 'default' : 'cursor'
            }, disableRipple: true, disableGutters: true, tabIndex: -1, selected: false, value: "picker", onClick: function (e) {
                e.preventDefault();
                e.stopPropagation();
            } }, { children: children })) })));
};
export default DatePickerSelect;
var templateObject_1, templateObject_2;
